/* eslint-disable */
import * as _ from 'lodash';

import {
  ChangeDetectorRef, ChangeDetectionStrategy,
  Component, AfterViewInit, ElementRef, ViewChild,
  HostBinding, OnDestroy,
} from '@angular/core';
import { initWheel, destroyWheel } from './wheel';

@Component({
  moduleId: module.id,
  selector: 'loader',
  styleUrls: ['loader.component.scss'],
  templateUrl: 'loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// export class LoaderComponent implements AfterViewInit{
export class LoaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('canvas', {static: false}) canvas: ElementRef | void;
  @ViewChild('animContainer', {static: false}) animContainer: ElementRef | void;
  @ViewChild('domOverlayContainer', {static: false}) domOverlayContainer: ElementRef | void;

  @HostBinding('class.show') isShow: boolean = false;
  @HostBinding('class.hide') isHide: boolean = false;

  stage: any;
  exportRoot: any;
  fnStartAnimation: any;
  AdobeAn: any = {};
  loadedGoogleCount: number = 0;
  prototype: any;
  lib: any;
  createjs = window.createjs;
  wheelInited: boolean = false;
  resizeCanvas: () => void;

  constructor(protected ref: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.initWheelComponent();
  }

  ngOnDestroy() {
    this.wheelInited = false;
    this.destroy();
    this.createjs.Ticker.reset();
    this.createjs.Ticker.removeAllEventListeners();
    this.createjs = null;
    this.AdobeAn = {};
  }

  show() {
    // ngOnDestroy nulls createjs; a stale @ViewChild can still call show()
    if (!this.createjs) return;
    if (!this.isShow) {
      this.isShow = true;
      this.isHide = false;
      this.init();
    }
  }

  hide() {
    this.isShow = false;
    this.isHide = true;
    _.delay(() => this.destroy(), 500);
  }

  init() {
    if (!this.wheelInited) this.initWheelComponent();
  	const comp = this.AdobeAn.getComposition("E92A82A681754F40A1C2DF8649335BAB");
  	this.lib = comp.getLibrary();
  	this.handleComplete({}, comp);
  }

  destroy() {
  	this.lib = null;
  	this.exportRoot = null;
  	this.stage = null;
    this.fnStartAnimation = null;
    this.isShow = false;
    this.isHide = false;
    window.removeEventListener('resize.wheel', this.resizeCanvas);
    if (this.createjs) this.createjs.Ticker.removeEventListener('tick');
  }

  handleComplete(evt: any, comp: any) {
  	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
  	const ss = comp.getSpriteSheet();
  	this.exportRoot = new this.lib.wheel();
  	this.stage = new this.lib.Stage(this.canvas && this.canvas.nativeElement);
  	this.stage.addChild(this.exportRoot);
  	//Registers the "tick" event listener.
  	this.fnStartAnimation = () => {
  		this.createjs.Ticker.setFPS(this.lib.properties.fps);
  		this.createjs.Ticker.addEventListener("tick", this.stage);
  	}

    //Code to support hidpi screens and responsive scaling.
  	const makeResponsive = (isResp: any, respDim: any, isScale: any, scaleType: any) => {
  		let lastW: any;
      let lastH: any;
      let lastS: any = 1;
  		this.resizeCanvas = () => {
  			const w = this.lib.properties.width, h = this.lib.properties.height;
  			const iw = window.innerWidth, ih=window.innerHeight;
  			let pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h;
        let sRatio = 1;
  			if(isResp) {
  				if((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
  					sRatio = lastS;
  				}
  				else if(!isScale) {
  					if(iw < w || ih < h)
  						sRatio = Math.min(xRatio, yRatio);
  				}
  				else if(scaleType == 1) {
  					sRatio = Math.min(xRatio, yRatio);
  				}
  				else if(scaleType == 2) {
  					sRatio = Math.max(xRatio, yRatio);
  				}
  			}
        window.addEventListener('resize.wheel', this.resizeCanvas);
    		this.resizeCanvas();
    		if (this.canvas && this.domOverlayContainer && this.animContainer) {
          this.canvas.nativeElement.width = w*pRatio*sRatio;
          this.canvas.nativeElement.height = h*pRatio*sRatio;
          this.canvas.nativeElement.style.width = this.domOverlayContainer.nativeElement.style.width = this.animContainer.nativeElement.style.width =  w*sRatio+'px';
          this.canvas.nativeElement.style.height = this.animContainer.nativeElement.style.height = this.domOverlayContainer.nativeElement.style.height = h*sRatio+'px';
        }
  			this.stage.scaleX = pRatio*sRatio;
  			this.stage.scaleY = pRatio*sRatio;
  			lastW = iw;
        lastH = ih;
        lastS = sRatio;
  		}
  	}
  	makeResponsive(false,'both',false,1);
  	this.AdobeAn.compositionLoaded(this.lib.properties.id);
  	this.fnStartAnimation();
  }

  private initWheelComponent() {
    initWheel(this.createjs, this.AdobeAn, this.exportRoot);
    this.wheelInited = true;
  }
}
/* eslint-enable */
